import { RouteConfig } from 'vue-router';

import { LocalStorage } from '@/enums/storage.enum';
import store from '@/store';

export const changePasswordRoute: RouteConfig = {
  name: 'changePassword',
  path: '/change-password',
  meta: { authorized: true },
  component: () => import(/* webpackChunkName: "ChangePassword" */ '@/views/changePassword/ChangePassword.vue'),
  beforeEnter: (to, from, next) => {
    store.commit('profile/setId', localStorage.getItem(LocalStorage.USER_ID));
    store.dispatch('profile/get').then(profile => {
      if (!profile.needsPasswordChange) {
        return next({ name: 'home' });
      }
      next();
    });
  }
};
